import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getUser = ({
  churchId,
  isDenomination = false,
  denominationId,
  userId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/users/${userId}`
  );
};

export const useUser = ({
  churchId,
  isDenomination = false,
  denominationId,
  userId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["user", userId, isDenomination ? denominationId : churchId],
    queryFn: () => getUser({ churchId, isDenomination, denominationId, userId })
  });
};
